import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import "./Index.css";

export default function StaffDirectory(props) {
  const { translations } = useSelector((state) => state.language);
  const t = useMemo(() => translations?.labels || {}, [translations]);

  return (
    <div className="staff-card">
      {/* Header */}
      <div className="staff-card-header">
        <h2>{props.title}</h2>
      </div>

      {/* Search */}
      <div className="search-box">
        <input
          type="text"
          placeholder={`${t.searchButton || "Search"}...`}
          value={props.searchTerm}
          onChange={(e) => props.setSearchTerm(e.target.value)}
        />
        <span className="search-icon">🔍</span>
      </div>

      {/* Table Header */}
      <div className="staff-table-header">
        <span className="staff-table-col-name">
          {t.staffName || "Staff Name"}
        </span>
        <span className="staff-table-col-contact">
          {t.contact || "Contact"}
        </span>
      </div>

      {/* List */}
      <ul className="staff-list">
        {props.loading ? (
          <li className="staff-item-empty">{t.loading || "Loading..."}</li>
        ) : props.filteredStaff.length === 0 ? (
          <li className="staff-item-empty">
            {t.noRecordsToDisplay || "No records to display"}
          </li>
        ) : (
          props.filteredStaff.map((staff, index) => (
            <React.Fragment key={staff.id}>
              <li className="staff-item">
                <div className="avatar">
                  {staff.image ? (
                    <img src={staff.image} alt={staff.name} />
                  ) : (
                    <span>👤</span>
                  )}
                </div>
                <div className="staff-info">
                  <span className="staff-name">{staff.name}</span>
                  <span className="staff-phone">{staff.phone}</span>
                </div>
              </li>
              {index < props.filteredStaff.length - 1 && (
                <hr className="staff-divider" />
              )}
            </React.Fragment>
          ))
        )}
      </ul>
    </div>
  );
}
